import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './App.css';
import RedirectPage from './pages/RedirectPage';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Popup from './components/PopupCoupon';
import Home from './pages/Home';
import Store from './pages/Store';
import CouponDetail from './components/CouponDetail'; 
import Navbar from './components/Navbar';
import StorePage from './pages/StorePage';
import Footer from './pages/Footer';
import Category from "./pages/Category";
import CategoryCoupons from "./components/CategoryCoupons";
import ContactPage from './pages/ContactPage';
import AuthPage from './pages/AuthPage';

function App() {
  return (
    <Router>
      <div className="App">
         <Navbar />
        <Popup />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/store" element={<Store />}/>
          <Route path="/categories" element={<Category />} />
        <Route path="/category/:categoryName" element={<CategoryCoupons />} />          
        <Route path="/coupon/:code" element={<CouponDetail />} />
          <Route path="/store/:storeSlug" element={<StorePage />} />
          <Route path="/redirect/:storeSlug/:couponIndex" element={<RedirectPage />} />
           <Route path="/contact" element={<ContactPage />}/>
             <Route path="/auth" element={<AuthPage />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
